import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const BootstrapModalWrapper = ({ id, title, size = "modal-md", children, closeBtn = true, footerClass, header = true }) => {
    useEffect(() => {
        const modalEl = document.getElementById(id);
        if (modalEl && window.bootstrap) {
            const modalInstance = new window.bootstrap.Modal(modalEl);
            window[`modal_${id}`] = modalInstance;
        }
    }, [id]);

    return ReactDOM.createPortal(
        <div id={id} className="modal fade" tabIndex="-1" aria-hidden="true">
            <div className={`modal-dialog ${size}`}>
                <div className="modal-content">
                    <div className={`modal-header ${!header ? "d-none" : ""}`}>
                        {title && <h5 className="modal-title">{title}</h5>}
                        <button type="button" className="btn-close btn ms_btn_ace border-0" data-dismiss="modal" aria-label="Close" />
                    </div>

                    {children}
                    <div className={`modal-footer ${footerClass}`}>
                        {
                            closeBtn ? <button
                                type="button"
                                className="btn ms_btn_ace btn-default MS_button"
                                data-dismiss="modal"
                            >
                                CLOSE
                            </button> :
                                <></>
                        }
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default BootstrapModalWrapper;